import * as React from 'react';
const SvgLightbulbFill = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M17.54 6.12a5.1 5.1 0 0 0-1.291-1.64 6 6 0 0 0-1.922-1.09A6.9 6.9 0 0 0 12.005 3c-.82 0-1.601.13-2.332.39a6 6 0 0 0-1.912 1.09c-.55.47-.98 1.01-1.29 1.64S6 7.42 6 8.16c0 .6.06 1.14.19 1.61.13.48.29.94.49 1.41s.41.97.631 1.51q.33.81.6 1.89c.18.72.32 1.57.42 2.57.021.27.121.47.291.62s.4.23.69.23h5.375c.29 0 .52-.08.69-.23.171-.15.271-.36.301-.62.09-1 .23-1.85.41-2.57q.27-1.08.6-1.89c.221-.54.431-1.05.631-1.51s.36-.93.49-1.41S18 8.76 18 8.16c0-.74-.16-1.42-.47-2.05zM15.458 19.27a.52.52 0 0 0-.22-.22.5.5 0 0 0-.18-.05H9.302c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22-.05.11-.05.25-.05.53v.4c0 .28 0 .42.05.53.05.09.12.17.22.22.06.03.14.05.25.05h5.6739999999999995c.28 0 .42 0 .53-.05a.52.52 0 0 0 .22-.22c.03-.06.04-.12.05-.22v-.99c0-.11-.02-.19-.05-.25z"
    />
  </svg>
);
export default SvgLightbulbFill;
